exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge-18-wrapper[data-v-ff84e37a]{width:240px;padding-bottom:10px}.listing-img[data-v-ff84e37a]{width:38px;height:38px;border-radius:50%;display:inline-block}", ""]);

// exports
